/* global $ */

import { Controller } from 'stimulus';
import debounce from '../helpers/debounce';

class ListCollapse extends Controller {
  connect() {
    const showToggler = parseInt(this.data.get('amount-of-items'), 10) > parseInt(this.data.get('amount-of-items-to-show'), 10);

    $(this.togglerTarget).toggle(showToggler);
    this.debouncedListHeight = debounce(this.setListHeight.bind(this), 200);

    this.setListHeight();
  }

  listHeightCalculation() {
    this.debouncedListHeight();
  }

  setListHeight(limitHeight = true) {
    let height = 0;

    $(this.itemTargets).each((i, item) => {
      if (limitHeight && i >= this.data.get('amount-of-items-to-show')) {
        return;
      }

      height += $(item).outerHeight(true);
    });

    $(this.listTarget).css('height', height);
  }

  toggleList() {
    const isExpanded = $(this.listTarget).attr('aria-expanded') === 'true';

    $(this.listTarget).attr('aria-expanded', !isExpanded);

    this.setListHeight(isExpanded);
    this.toggleTogglerText(isExpanded);
  }

  toggleTogglerText(isExpanded) {
    $(this.togglerTarget)
      .attr('aria-expanded', !isExpanded)
      .find('span')
      .text(isExpanded ? this.data.get('collapsed-text') : this.data.get('expanded-text'));
  }
}

ListCollapse.targets = [
  'list',
  'item',
  'toggler',
];

export default ListCollapse;
